import { render, staticRenderFns } from "./ModalAlerts.vue?vue&type=template&id=54cb7d8e&scoped=true"
import script from "./ModalAlerts.vue?vue&type=script&lang=js"
export * from "./ModalAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cb7d8e",
  null
  
)

export default component.exports